import { FrequencyPair } from './frequency-pair';

export enum FrequencyTypeCode {
    Low = 'LOW',
    OpFx = 'OPFIX',
    VHF = 'VHF',
    Between175And300MHz = `220's`,
    Between406And416MHz = '406-416 MHZ',
    Between420And450MHz = `420's`,
    UHF = 'UHF',
    TBand = 'T-Band',
    Between806And870MHz = '800 MHz',
    Between928And957MHz = 'MAS',
    Between935And940MHz = '900 MHz',
    Between1427And1432MHz = '1.4 GHz',
    Between3650And3700MHz = '3.65 GHz',
    Between4940And4980 = '4.9 GHz',
    Between896And901MHz = '896-901 MHZ',
}

export const FrequencyTypeToFrequencyPair: Record<
    FrequencyTypeCode,
    FrequencyPair
> = {
    [FrequencyTypeCode.Low]: { low: 25.0, high: 49.99999 },
    [FrequencyTypeCode.OpFx]: { low: 50.0, high: 149.99999 },
    [FrequencyTypeCode.VHF]: { low: 150.0, high: 174.99999 },
    [FrequencyTypeCode.Between175And300MHz]: { low: 175.0, high: 299.99999 },
    [FrequencyTypeCode.Between406And416MHz]: { low: 406.0, high: 416.0 },
    [FrequencyTypeCode.Between420And450MHz]: { low: 420.0, high: 449.99999 },
    [FrequencyTypeCode.UHF]: { low: 450.0, high: 469.99999 },
    [FrequencyTypeCode.TBand]: { low: 470.0, high: 512.0 },
    [FrequencyTypeCode.Between806And870MHz]: { low: 806.0, high: 869.99999 },
    [FrequencyTypeCode.Between928And957MHz]: { low: 928.0, high: 957.0 },
    [FrequencyTypeCode.Between935And940MHz]: { low: 935.0, high: 939.99999 },
    [FrequencyTypeCode.Between1427And1432MHz]: { low: 1427.0, high: 1432.0 },
    [FrequencyTypeCode.Between3650And3700MHz]: { low: 3650.0, high: 3700.0 },
    [FrequencyTypeCode.Between4940And4980]: { low: 4940.0, high: 4980.0 },
    [FrequencyTypeCode.Between896And901MHz]: { low: 896.0, high: 901.0 },
};
